import { api_escalateCase, api_getCase } from '../../utils/Case/Case';
import {
  CASE_GET_CASE,
  CASE_TOGGLE_LOADING,
  CASE_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  CASE_TOGGLE_ACTIVITY_IS_OPEN,
  TICKET_SET_SHOW_COMMENT_FORM,
  TICKET_SET_COMMENT_VALUE,
  ISetTicketCommentValue,
  ISetTicketShowCommentForm,
  IAssignActivityIsOpenFields,
  ISetCaseAction,
  IToggleCaseLoadingAction,
  IToggleActivity,
  ISetTicketCommentProcessing,
  ISetCaseDescError,
  TICKET_SET_COMMENT_PROCESSING,
  CASE_SET_DESC_ERROR,
  CASE_UPDATE_ESCALATION_NOTE,
  IUpdateEscalationNote,
  CASE_TOGGLE_MODAL,
  CASE_ESCALATION_TOGGLE_MODAL,
  CASE_SET_ESCALATION_MODAL_ERROR_TEXT,
  TOGGLE_CASE_REASON_DROPDOWN,
  ITogglCaseReasonDropdownAction,
  IToggleCaseModalLoadingAction,
  CASE_TOGGLE_MODAL_LOADING,
  CASE_TOGGLE_ESCALATION_MODAL_LOADING,
  CASE_ESCALATE_CASE,
  IToggleCaseEscalationModalLoadingAction,
  CASE_SET_ACTIVITY,
  CASE_TOGGLE_ACTIVITY_CONTENT_LOADING,
  IToggleCaseActivityContentLoading, TICKET_SET_ACTIVITY_ERROR, IAddTicketActivityError,
} from './types';

import { defaultErrorFeedback, errorFeedback } from '../../actions/feedback';
import { setSystemError } from '../system/actions';
import { api_getCaseActivity, createCase } from '../../utils/Cases/Cases';
import { addCaseToCases } from '../cases/actions';
import {api_deletePortalUserComment} from "../../utils/PortalUserComment/PortalUserCommentService";
import { api_getTicket } from 'utils/Ticket/ticket';

export const setTicketCommentValue = (value): ISetTicketCommentValue => ({ type: TICKET_SET_COMMENT_VALUE, value });
export const setTicketCommentFormOpen = (): ISetTicketShowCommentForm => ({ type: TICKET_SET_SHOW_COMMENT_FORM });
export const setCommentProcessing = (payload): ISetTicketCommentProcessing => ({ type: TICKET_SET_COMMENT_PROCESSING, payload });
export const setDescError = (payload): ISetCaseDescError => ({ type: CASE_SET_DESC_ERROR, payload });
export const caseUpdateEscalationNote = (payload): IUpdateEscalationNote => ({ type: CASE_UPDATE_ESCALATION_NOTE, payload });
export const caseToggleModal = () => ({ type: CASE_TOGGLE_MODAL });
export const caseEscalationToggleModal = () => ({ type: CASE_ESCALATION_TOGGLE_MODAL });
export const caseEscalate = () => ({ type: CASE_ESCALATE_CASE });
export const caseEscalationSetErrorText = (payload) => ({ type: CASE_SET_ESCALATION_MODAL_ERROR_TEXT, payload });
export const toggleCaseReasonDropdownOpen = (): ITogglCaseReasonDropdownAction => ({ type: TOGGLE_CASE_REASON_DROPDOWN });

export function updateCaseEscalated(caseId, escalationNote) {

  return (dispatch) => api_escalateCase(caseId, escalationNote).then((result) => {

    if (result.status === 200) {

      return true;

    }
    dispatch(errorFeedback('Could not Escalate case'));
    return false;

  });

}
export function deletePortalUserComment(commentId) {
  return (dispatch) => api_deletePortalUserComment(commentId)
    .then((result) => {
      if (result.status >= 200 && result.status < 300) {
        return true;
      }
      dispatch(errorFeedback('Could not delete comment'));
      return false;
    });
}

function setCase(data): ISetCaseAction {

  return {
    type: CASE_GET_CASE,
    data,
  };

}
export function toggleCaseLoading(): IToggleCaseLoadingAction {

  return {
    type: CASE_TOGGLE_LOADING,
  };

}

export const toggleCaseModalLoading = (): IToggleCaseModalLoadingAction => ({ type: CASE_TOGGLE_MODAL_LOADING });
export const toggleCaseEscalationModalLoading = (): IToggleCaseEscalationModalLoadingAction => ({ type: CASE_TOGGLE_ESCALATION_MODAL_LOADING });
export function getCase(caseId, query: { include: string }) {

  return (dispatch) => api_getCase(caseId, query).then((result) => {

    if (result.status === 200) {

      dispatch(setCase(result.data));

    } else if (result.data.error && result.data.error.id) {

      dispatch(errorFeedback(`Could not get case for id ${result.data.error.id}`));

    } else {

      dispatch(defaultErrorFeedback());

    }

  });

}

export function getTicket(ticketId, query: { include: string }) {

  return (dispatch) => api_getTicket(ticketId, query).then((result) => {

    if (result.status === 200) {

      dispatch(setCase(result.data));

    } else if (result.data.error && result.data.error.id) {

      dispatch(errorFeedback(`Could not get case for id ${result.data.error.id}`));

    } else {

      dispatch(defaultErrorFeedback());

    }

  });

}
export function assignActivityIsOpenFields(): IAssignActivityIsOpenFields {

  return {
    type: CASE_ASSIGN_ACTIVITY_IS_OPEN_FIELDS,
  };

}
export function toggleActivity(id): IToggleActivity {

  return {
    type: CASE_TOGGLE_ACTIVITY_IS_OPEN,
    id,
  };

}

export function toggleActivityContentLoading(id): IToggleCaseActivityContentLoading {

  return {
    type: CASE_TOGGLE_ACTIVITY_CONTENT_LOADING,
    id,
  };

}

const setCaseActivity = (data) => ({
  type: CASE_SET_ACTIVITY,
  data,
});
export const createNewCase = (object) => (dispatch) => createCase(object).then((result) => {

  if (result.status === 200) {

    dispatch(addCaseToCases({ ...result.data, ticketNumber: result.data.ticketNumber }));
    return result.data;

  }

  return false;

});

export const getCaseActivity = (caseId, activityId) => (dispatch) => api_getCaseActivity(caseId, activityId).then((result) => {

  if (result.status === 200) {

    dispatch(setCaseActivity(result.data));
    return true;

  }

  return false;

});

export function setActivityError(id, error): IAddTicketActivityError {

  return {
    type: TICKET_SET_ACTIVITY_ERROR,
    id,
    error
  };

}
